export default __webpack_public_path__ + "static/media/sidebarImage.f0872a2b.svg";